import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

const Loader = () => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <ArrowPathIcon className="animate-spin h-24 w-24 text-red-500" />
        </div>
    );
};

export default Loader;
